import { render, staticRenderFns } from "./SnippetDetail.vue?vue&type=template&id=db40d0d6&"
import script from "./SnippetDetail.vue?vue&type=script&lang=js&"
export * from "./SnippetDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports